import React from 'react'
import VisionPlay from './vision/VisionPlay'

const Vision = () => <VisionPlay />

export default Vision
